import { render, staticRenderFns } from "./OrderReplacementNew.vue?vue&type=template&id=53fdc437&scoped=true"
import script from "./OrderReplacementNew.vue?vue&type=script&lang=ts"
export * from "./OrderReplacementNew.vue?vue&type=script&lang=ts"
import style0 from "./OrderReplacementNew.vue?vue&type=style&index=0&id=53fdc437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdc437",
  null
  
)

export default component.exports